module.exports = __webpack_public_path__ + "static/media/elementary-image.e4b8fdfd.jpg";